// components/Header.js
"use client";
import Image from "next/image";
import { Loader2, User, Crown } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function Header() {
  const { user, buyerInfo, loading } = useAuth();
  
  // Verificar se é VIP (usa coluna separada is_vip)
  const isVip = buyerInfo?.is_vip === true;

  const handleGoToProfile = () => {
    window.location.href = "/profile";
  };

  return (
    <header className="border-b border-gray-200 fixed top-0 w-full h-[70px] py-3 px-5 flex justify-between items-center bg-white z-100">
      <Image src="/images/moneyclub.webp" alt="Money Club" height={40} width={90} />
      
      {/* Right side content */}
      <div className="flex items-center gap-3">
        {loading ? (
          <div className="text-blue-500">
            <Loader2 className="animate-spin" />
          </div>
        ) : user ? (
          <button 
            onClick={handleGoToProfile}
            className="focus:outline-none relative"
          >
            {/* Coroa VIP no topo */}
            {isVip && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10">
                <Crown className="w-5 h-5 text-amber-500 fill-amber-400 drop-shadow-lg" />
              </div>
            )}
            
            {/* Avatar */}
            <div className={`h-10 w-10 rounded-full flex items-center justify-center cursor-pointer hover:scale-105 transition-all ${
              isVip 
                ? "bg-gradient-to-br from-amber-500 via-yellow-400 to-amber-600 shadow-lg shadow-amber-500/50 hover:shadow-xl hover:shadow-amber-500/60" 
                : "bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/30 hover:shadow-xl"
            }`}>
              <User className="h-5 w-5 text-white" />
            </div>
          </button>
        ) : (
          <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5">
            <span className="text-gray-500 text-sm font-medium">Not signed in</span>
          </div>
        )}
      </div>
    </header>
  );
}
